// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1xTSM","info":"PatientInfo_info__2iuXo"};